import { Box, Typography } from "@mui/material";
import {
  ALREADY_HAVE_ACCOUNT_MESSAGE,
  LOGIN_HERE,
} from "../../constants/string";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../constants/paths";
import { makeStyles } from "@mui/styles";
import theme from "../../CustomTheme";
const useStyles = makeStyles({
  link: {
    textDecoration: theme.typography.decoration.textDecoration,
    cursor: "pointer",
    color: theme.typography.decoration.textDecorationColor,
  },
});

const LoginRedirect = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const handleOnclick = () => {
    navigate(LOGIN);
  };
  return (
    <Box sx={{ mt: 2, textAlign: "center" }}>
      <Typography variant="body2">
        {ALREADY_HAVE_ACCOUNT_MESSAGE}
        <Typography
          component="span"
          onClick={handleOnclick}
          className={classes.link}
        >
          {LOGIN_HERE}
        </Typography>
      </Typography>
    </Box>
  );
};
export default LoginRedirect;
